<template>
    <nav
        class="navbar navbar-expand-lg bg-body-tertiary"
        :class="{
            'navbar--light': isLight,
            'navbar--mobile-fixed': isMobileNav,
            'navbar--mobile-hidden': isMobileNav && !mobileNavVisible,
        }"
    >
        <div class="container-fluid">
            <router-link to="/" class="navbar-brand ps-3"><img :src="isLight ? require('@/assets/logos/logo_white.svg') : require('@/assets/logos/logo_black.svg')" alt="logo gs" loading="eager" decoding="async"></router-link>
            <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasNavbar"
                aria-controls="offcanvasNavbar"
                aria-label="Toggle navigation"
                @click="onMobileMenuOpen"
            >
            <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse navbar-desktop-menu">
                <ul class="navbar-nav justify-content-end align-items-center flex-grow-1 pe-3">
                    <li class="nav-item">
                        <router-link to="/" class="nav-link p-14" aria-current="page">Home</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/sobre-gs" class="nav-link p-14" aria-current="page">Sobre GS</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/equipo" class="nav-link p-14" aria-current="page">Equipo</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/nuestro-contenido" class="nav-link p-14" aria-current="page">Nuestro Contenido</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/gs-tech-lab" class="nav-link p-14" aria-current="page">GS Tech Lab</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/division-sur" class="nav-link p-14" aria-current="page">División Sur</router-link>
                    </li>
                    <li class="nav-item">
                        <ButtonComp
                            :buttonText="'Contacto'"
                            :btnColor="'btn-primary'"
                            :hashTag="'/contacto'"
                            :displayLink="true"
                        />
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    <div
        class="offcanvas offcanvas-end"
        tabindex="-1"
        id="offcanvasNavbar"
        aria-labelledby="offcanvasNavbarLabel"
        ref="offcanvasEl"
    >
        <div class="offcanvas-header">
            <router-link to="/" class="navbar-brand" @click="handleNavItemClick">
                <img :src="require('@/assets/logos/logo_black.svg')" alt="logo gs" loading="lazy" decoding="async">
            </router-link>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <ul class="navbar-nav justify-content-end align-items-center text-center flex-grow-1 pe-3">
                <li class="nav-item">
                    <p class="number-menu">01</p>
                    <router-link
                        to="/"
                        class="nav-link p-14"
                        aria-current="page"
                        @click="handleNavItemClick"
                    >Home</router-link>
                </li>
                <li class="nav-item">
                    <p class="number-menu">02</p>
                    <router-link
                        to="/sobre-gs"
                        class="nav-link p-14"
                        aria-current="page"
                        @click="handleNavItemClick"
                    >Sobre GS</router-link>
                </li>
                <li class="nav-item">
                    <p class="number-menu">03</p>
                    <router-link
                        to="/equipo"
                        class="nav-link p-14"
                        aria-current="page"
                        @click="handleNavItemClick"
                    >Equipo</router-link>
                </li>
                <li class="nav-item">
                    <p class="number-menu">04</p>
                    <router-link
                        to="/nuestro-contenido"
                        class="nav-link p-14"
                        aria-current="page"
                        @click="handleNavItemClick"
                    >Nuestro Contenido</router-link>
                </li>
                <li class="nav-item">
                    <p class="number-menu">05</p>
                    <router-link
                        to="/gs-tech-lab"
                        class="nav-link p-14"
                        aria-current="page"
                        @click="handleNavItemClick"
                    >GS Tech Lab</router-link>
                </li>
                <li class="nav-item">
                    <p class="number-menu">06</p>
                    <router-link
                        to="/division-sur"
                        class="nav-link p-14"
                        aria-current="page"
                        @click="handleNavItemClick"
                    >División Sur</router-link>
                </li>
                <li class="nav-item" @click="handleNavItemClick">
                    <p class="number-menu">07</p>
                    <ButtonComp
                        :buttonText="'Contacto'"
                        :btnColor="'btn-primary'"
                        :hashTag="'/contacto'"
                        :displayLink="true"
                    />
                </li>
            </ul>
            <img src="@/assets/logos/arrow_white.svg" alt="flecha blanca" class="arrow-white" loading="lazy" decoding="async">
        </div>
    </div>
</template>

<script>    
import ButtonComp from '@/components/ButtonComp.vue'
import Offcanvas from 'bootstrap/js/dist/offcanvas'
import { mapGetters } from 'vuex'
export default {
    name: 'NavBar',
    components: {
        ButtonComp
    },
    data() {
        return {
            isWideViewport: false,
            mobileNavVisible: true,
            lastScrollY: 0,
            offcanvasOpen: false,
        }
    },
    computed: {
        ...mapGetters(['casoByLink']),
        isMobileNav() {
            return !this.isWideViewport
        },
        isLightRoute() {
            const name = this.$route?.name

            // /:slug resuelve como caso-destacado aunque el slug no exista (404)
            if (name === 'caso-destacado') {
                const slug = String(this.$route.params.slug ?? '').trim()
                return Boolean(this.casoByLink(slug))
            }

            return (
                name === 'home'
                || this.$route?.path === '/'
                || name === 'division-sur'
                || name === 'equipo'
                || name === 'nuestro-contenido'
            )
        },
        isLight() {
            return this.isLightRoute && this.isWideViewport
        },
    },
    watch: {
        '$route'() {
            this.lastScrollY = 0
            this.mobileNavVisible = true
        },
        isMobileNav(isMobile) {
            if (isMobile) {
                this.enableMobileNav()
            } else {
                this.disableMobileNav()
            }
        },
    },
    mounted() {
        this.updateViewportWidth()
        window.addEventListener('resize', this.updateViewportWidth)
        if (this.isMobileNav) {
            this.enableMobileNav()
        }
        this.bindOffcanvasEvents()
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateViewportWidth)
        this.disableMobileNav()
        this.unbindOffcanvasEvents()
    },
    methods: {
        updateViewportWidth() {
            const wasMobile = this.isMobileNav
            this.isWideViewport = window.innerWidth > 1000
            if (this.isMobileNav && !wasMobile) {
                this.enableMobileNav()
            } else if (!this.isMobileNav && wasMobile) {
                this.disableMobileNav()
            }
        },
        enableMobileNav() {
            document.body.classList.add('has-mobile-navbar')
            this.lastScrollY = window.scrollY
            this.mobileNavVisible = window.scrollY <= 10
            this.$nextTick(() => this.syncMobileNavHeight())
            window.addEventListener('scroll', this.onMobileScroll, { passive: true })
        },
        disableMobileNav() {
            document.body.classList.remove('has-mobile-navbar')
            document.documentElement.style.removeProperty('--mobile-nav-height')
            window.removeEventListener('scroll', this.onMobileScroll)
            this.mobileNavVisible = true
        },
        syncMobileNavHeight() {
            const height = this.$el?.offsetHeight
            if (height) {
                document.documentElement.style.setProperty('--mobile-nav-height', `${height}px`)
            }
        },
        bindOffcanvasEvents() {
            const el = this.$refs.offcanvasEl
            if (!el) return
            el.addEventListener('show.bs.offcanvas', this.onOffcanvasShow)
            el.addEventListener('hidden.bs.offcanvas', this.onOffcanvasHidden)
        },
        unbindOffcanvasEvents() {
            const el = this.$refs.offcanvasEl
            if (!el) return
            el.removeEventListener('show.bs.offcanvas', this.onOffcanvasShow)
            el.removeEventListener('hidden.bs.offcanvas', this.onOffcanvasHidden)
        },
        onOffcanvasShow() {
            this.offcanvasOpen = true
            this.mobileNavVisible = true
        },
        onOffcanvasHidden() {
            this.offcanvasOpen = false
        },
        onMobileMenuOpen() {
            if (!this.isMobileNav) return
            this.mobileNavVisible = true
        },
        onMobileScroll() {
            if (!this.isMobileNav || this.offcanvasOpen) return

            const current = window.scrollY
            const delta = current - this.lastScrollY

            if (current <= 10) {
                this.mobileNavVisible = true
            } else if (delta > 8) {
                this.mobileNavVisible = false
            } else if (delta < -8) {
                this.mobileNavVisible = true
            }

            this.lastScrollY = current
        },
        handleNavItemClick() {
            // Solo cerramos en mobile (misma breakpoint que tu CSS del navbar)
            if (!window.matchMedia('(max-width: 1000px)').matches) return

            const el = document.getElementById('offcanvasNavbar')
            if (!el) return

            const instance = Offcanvas.getInstance(el) || new Offcanvas(el)
            instance.hide()

            // Cuando hay navegación inmediata, Bootstrap a veces no alcanza a limpiar
            // el backdrop antes de que el componente se desmonte.
            setTimeout(() => {
                document
                    .querySelectorAll('.offcanvas-backdrop, .modal-backdrop')
                    .forEach((node) => node.remove())
                document.body.classList.remove('modal-open')
            }, 250)
        },
    },
}
</script>